import { listDomainVerifications } from '@/api/enterprise'

export const domainVerificationsQueryKey = ['domainVerifications'] as const

export const domainVerificationsQuery = () => ({
  queryKey: domainVerificationsQueryKey,
  queryFn: () => listDomainVerifications(),
})
